const Loading =  () => {
    return(
        <section>
            <h1>Carregando...</h1>
        </section>
    )
}

export default Loading;